/** True if cart line counts toward free colour-sample limit (NL/DE product types + line properties). */
function cartLineItemIsSample(item) {
  if (!item) return false;
  const t = String(item.product_type || '').toLowerCase();
  if (t === 'sample' || t.includes('muster') || t.includes('farbprobe')) return true;
  if (t.includes('colour swatch') || t.includes('color swatch')) return true;
  const props = item.properties || {};
  const keys = typeof props === 'object' && !Array.isArray(props) ? Object.keys(props) : [];
  for (const key of keys) {
    const pk = String(key).toLowerCase().trim();
    if (pk.includes('sample van product') || pk.includes('sample from product') || pk.includes('produktmuster')) return true;
  }
  return false;
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items');
        this.cartNotification = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.ctaButton = !this.closest('.section-featured-product') ?
          this.closest('.section')?.querySelector('.sticky-cta .button') : null;
        this.sampleSideTabButton = !this.closest('.section-featured-product')
          ? this.closest('.section')?.querySelector('.sample-side-tab')
          : null;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

      }

      isSampleProduct() {
        return this.dataset?.sampleProduct === 'true' || (this.dataset?.productType || '') === 'Sample';
      }

      connectedCallback() {
        this.refreshSampleUiState();
        this.cartUpdateUnsubscriber = typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined'
          ? subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshSampleUiState())
          : undefined;
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.ctaButton) {
          this.ctaButton.removeEventListener('click', this.ctaButtonListener);
        }
        if (this.sampleSideTabButton) {
          this.sampleSideTabButton.removeEventListener('click', this.sampleSideTabButtonListener);
        }
      }

      refreshSampleUiState() {
        if (this.isSampleProduct()) this.updateSampleButtonState();
        if (this.sampleSideTabButton) this.updateSampleSideTabState();
      }

      async updateSampleButtonState() {
        const maxSamples = parseInt(this.dataset?.maxSamples || '5', 10);
        if (!this.isSampleProduct() || !this.submitButton) return;
        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const samplesInCart = (cart.items || []).reduce(
            (sum, item) => (cartLineItemIsSample(item) ? sum + item.quantity : sum),
            0
          );
          const atLimit = samplesInCart >= maxSamples;
          this.submitButton.disabled = atLimit;
          if (atLimit) this.submitButton.setAttribute('aria-disabled', 'true');
          else this.submitButton.removeAttribute('aria-disabled');
          const labelSpan = this.submitButton.querySelector('.product-form__submit-label') || this.submitButton.querySelector('span');
          if (labelSpan) {
            labelSpan.textContent = atLimit
              ? 'Max. 5 kleurstalen bereikt'
              : (window.variantStrings?.addToCart || this.dataset?.addToCartLabel || 'In winkelwagen');
          }
          if (this.ctaButton) {
            this.ctaButton.disabled = atLimit;
            if (atLimit) this.ctaButton.setAttribute('aria-disabled', 'true');
            else this.ctaButton.removeAttribute('aria-disabled');
          }
        } catch (err) {
          console.warn('Sample button state update failed', err);
        }
      }

      ctaButtonClickHandler() {
        if (this.submitButton && this.submitButton.classList.contains('product-form__submit')) {
          this.submitButton.click();
        }
      }

      async updateSampleSideTabState() {
        if (!this.sampleSideTabButton) return;

        const variantId = this.sampleSideTabButton.dataset?.sampleVariantId;
        const maxSamples = parseInt(this.sampleSideTabButton.dataset?.maxSamples || this.dataset?.maxSamples || '5', 10);
        const labelSpan = this.sampleSideTabButton.querySelector('span');

        if (!variantId) {
          this.sampleSideTabButton.disabled = true;
          this.sampleSideTabButton.setAttribute('aria-disabled', 'true');
          if (labelSpan) labelSpan.textContent = 'Gratis kleurstalen';
          return;
        }

        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const samplesInCart = (cart.items || []).reduce(
            (sum, item) => (cartLineItemIsSample(item) ? sum + item.quantity : sum),
            0
          );
          const atLimit = samplesInCart >= maxSamples;
          this.sampleSideTabButton.disabled = atLimit;
          if (atLimit) this.sampleSideTabButton.setAttribute('aria-disabled', 'true');
          else this.sampleSideTabButton.removeAttribute('aria-disabled');
          if (labelSpan) {
            labelSpan.textContent = atLimit ? 'Max. 5 kleurstalen bereikt' : 'Gratis kleurstalen';
          }
        } catch (err) {
          console.warn('Sample side-tab state update failed', err);
        }
      }

      sampleSideTabClickHandler(evt) {
        evt.preventDefault();
        if (!this.sampleSideTabButton || this.sampleSideTabButton.getAttribute('aria-disabled') === 'true') return;

        const variantId = this.sampleSideTabButton.dataset?.sampleVariantId;
        if (!variantId) return;

        this.addSampleVariantToCart(variantId);
      }

      getSectionsToRender() {
        let sections = [];
        if (this.cartDrawer) {
          sections = this.cartDrawer.getSectionsToRender().map((section) => section.id);
        }
        if (this.cartNotification) {
          const cartNotificationSections = this.cartNotification.getSectionsToRender().map((section) => section.id);
          sections = [...sections, ...cartNotificationSections];
        }
        if (this.cartItems) {
          const cartItemsSections = this.cartItems.getSectionsToRender().map((section) => section.section);
          sections = [...sections, ...cartItemsSections];
        }
        return [...new Set(sections)];
      }

      renderCartResponse(response, variantId) {
        if (response.sections === null && document.querySelector('.section-main-cart')) {
          window.location.reload();
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId || response.variant_id,
          cartData: response,
        });

        if (this.cartDrawer) this.cartDrawer.renderContents(response);
        if (this.cartItems) this.cartItems.renderContents(response);
        if (this.cartNotification) this.cartNotification.renderContents(response);
      }

      async addSampleVariantToCart(variantId) {
        const maxSamples = parseInt(this.sampleSideTabButton?.dataset?.maxSamples || this.dataset?.maxSamples || '5', 10);

        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const samplesInCart = (cart.items || []).reduce(
            (sum, item) => (cartLineItemIsSample(item) ? sum + item.quantity : sum),
            0
          );

          if (samplesInCart >= maxSamples) {
            this.handleErrorMessage(`Maximaal ${maxSamples} kleurstalen per bestelling. Je hebt al ${samplesInCart} in je winkelwagen.`);
            this.updateSampleSideTabState();
            return;
          }
        } catch (err) {
          console.warn('Sample limit check failed', err);
        }

        this.handleErrorMessage();

        this.sampleSideTabButton.setAttribute('aria-disabled', 'true');
        this.sampleSideTabButton.classList.add('loading');
        this.sampleSideTabButton.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('properties[Sample van product]', this.sampleSideTabButton.dataset?.productHandle || this.closest('.product')?.dataset?.productHandle || '');

        const sections = this.getSectionsToRender();
        if (sections.length > 0) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);

          if (theme.settings.cartDrawer.atcAction === 'drawer' && this.cartDrawer) {
            this.cartDrawer.setActiveElement(document.activeElement);
          } else if (theme.settings.cartDrawer.atcAction === 'notification' && this.cartNotification) {
            this.cartNotification.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || response.message);
              if (this.cartDrawer) this.cartDrawer.reload();
              return;
            } else if (theme.settings.cartDrawer.atcAction === 'page') {
              window.location = window.routes.cart_url;
              return;
            }

            this.renderCartResponse(response, variantId);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.sampleSideTabButton.classList.remove('loading');
            this.sampleSideTabButton.querySelector('.loading__spinner')?.classList.add('hidden');
            if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
            if (this.cartNotification && this.cartNotification.classList.contains('is-empty')) this.cartNotification.classList.remove('is-empty');
            this.updateSampleSideTabState();
          });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const productForm = this.closest?.('product-form') || this;
        const maxSamples = parseInt(productForm.dataset?.maxSamples || '5', 10);

        if (this.isSampleProduct() && maxSamples > 0) {
          const quantityToAdd = parseInt(this.form.querySelector('[name="quantity"]')?.value || '1', 10) || 1;
          try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            const samplesInCart = (cart.items || []).reduce(
              (sum, item) => (cartLineItemIsSample(item) ? sum + item.quantity : sum),
              0
            );
            if (samplesInCart + quantityToAdd > maxSamples) {
              this.handleErrorMessage(
                `Maximaal ${maxSamples} kleurstalen per bestelling. Je hebt al ${samplesInCart} in je winkelwagen.`
              );
              return;
            }
          } catch (err) {
            console.warn('Sample limit check failed', err);
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        if (this.ctaButton) {
          this.ctaButton.setAttribute('aria-disabled', true);
          this.ctaButton.querySelector('.loading__spinner')?.classList.remove('hidden');
          this.ctaButton.classList.add('loading');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const sections = this.getSectionsToRender();

        if (sections.length > 0) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);

          if (theme.settings.cartDrawer.atcAction === 'drawer' && this.cartDrawer) {
           this.cartDrawer.setActiveElement(document.activeElement);
          } else if (theme.settings.cartDrawer.atcAction === 'notification' && this.cartNotification) {
            this.cartNotification.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (this.cartDrawer) this.cartDrawer.reload();

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              if (this.ctaButton) {
                this.ctaButton.setAttribute('aria-disabled', true);
                this.ctaButton.querySelector('span').classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (theme.settings.cartDrawer.atcAction === 'page') {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.renderCartResponse(response, formData.get('id'));
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (!this.error) {
              this.renderCartResponse(response, formData.get('id'));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
            if (this.cartNotification && this.cartNotification.classList.contains('is-empty')) this.cartNotification.classList.remove('is-empty');
            if (this.isSampleProduct()) {
              this.updateSampleButtonState();
            } else if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (this.ctaButton) {
              this.ctaButton.classList.remove('loading');
              if (!this.isSampleProduct() && !this.error) this.ctaButton.removeAttribute('aria-disabled');
              this.ctaButton.querySelector('.loading__spinner')?.classList.add('hidden');
            }
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            publish('quick-buy-action-complete');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          // Scroll to the error if needed
          const elementRect = this.errorMessage.getBoundingClientRect();
          const isVisible = elementRect.top >= 0 && elementRect.bottom <= window.innerHeight && elementRect.top >= 100;

          // If the element is not visible or if the top of the element is closer than 100px to the top of the viewport
          if (!isVisible) {
            const topPosition = elementRect.top + window.pageYOffset - 150; // Calculate position with 150px padding

            window.scrollTo({
              top: topPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  );
}

/** Free colour-sample units currently in the cart. */
async function fetchSampleCountInCart() {
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  return (cart.items || []).reduce((sum, item) => (cartLineItemIsSample(item) ? sum + item.quantity : sum), 0);
}

/**
 * Reflects the free-sample limit on every sample button on the page (PDP side tab,
 * product cards). Pass a known count to skip the extra cart fetch.
 */
async function syncSampleButtonStates(knownCount) {
  const buttons = document.querySelectorAll('[data-sample-variant-id]');
  if (!buttons.length) return;

  let samplesInCart = knownCount;
  if (typeof samplesInCart !== 'number') {
    try {
      samplesInCart = await fetchSampleCountInCart();
    } catch (err) {
      console.warn('Sample state sync failed', err);
      return;
    }
  }

  buttons.forEach((button) => {
    const maxSamples = parseInt(button.dataset?.maxSamples || '5', 10);
    const atLimit = maxSamples > 0 && samplesInCart >= maxSamples;

    button.classList.toggle('is-sample-limit-reached', atLimit);
    if (atLimit) {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('title', `Max. ${maxSamples} kleurstalen bereikt`);
    } else {
      button.removeAttribute('aria-disabled');
      if (button.dataset?.sampleFor) button.setAttribute('title', 'Gratis kleurstaal aanvragen');
    }
  });
}

// One sample add at a time: the limit check reads the cart before adding, so concurrent
// clicks (double-click, or two cards in quick succession) would all pass it.
async function addSampleSideTabToCart(button) {
  if (window.sampleAddPending) return;
  window.sampleAddPending = true;
  try {
    await addSampleToCartUnlocked(button);
  } finally {
    window.sampleAddPending = false;
  }
}

async function addSampleToCartUnlocked(button) {
  const variantId = button?.dataset?.sampleVariantId;
  if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

  const maxSamples = parseInt(button.dataset?.maxSamples || '5', 10);
  if (maxSamples > 0) {
    try {
      const samplesInCart = await fetchSampleCountInCart();
      if (samplesInCart >= maxSamples) {
        syncSampleButtonStates(samplesInCart);
        return;
      }
    } catch (err) {
      console.warn('Sample limit check failed', err);
    }
  }

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  button.querySelector('.loading__spinner')?.classList.remove('hidden');

  const cartDrawer = document.querySelector('cart-drawer');
  const cartItems = document.querySelector('cart-items');
  const cartNotification = document.querySelector('cart-notification');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');
  formData.append('properties[Sample van product]', button.dataset?.sampleFor || button.dataset?.productHandle || '');

  let sections = [];
  if (cartDrawer) {
    sections = cartDrawer.getSectionsToRender().map((section) => section.id);
  }
  if (cartNotification) {
    const cartNotificationSections = cartNotification.getSectionsToRender().map((section) => section.id);
    sections = [...sections, ...cartNotificationSections];
  }
  if (cartItems) {
    const cartItemsSections = cartItems.getSectionsToRender().map((section) => section.section);
    sections = [...sections, ...cartItemsSections];
  }

  if (sections.length > 0) {
    formData.append('sections', [...new Set(sections)]);
    formData.append('sections_url', window.location.pathname);

    if (theme.settings.cartDrawer.atcAction === 'drawer' && cartDrawer) {
      cartDrawer.setActiveElement(document.activeElement);
    } else if (theme.settings.cartDrawer.atcAction === 'notification' && cartNotification) {
      cartNotification.setActiveElement(document.activeElement);
    }
  }

  config.body = formData;

  try {
    const response = await fetch(`${routes.cart_add_url}`, config);
    const data = await response.json();

    if (data.status) {
      console.error('Sample side-tab add to cart failed', data);
      return;
    }

    if (theme.settings.cartDrawer.atcAction === 'page') {
      window.location = window.routes.cart_url;
      return;
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'sample-side-tab',
      productVariantId: variantId,
      cartData: data,
    });

    if (cartDrawer) cartDrawer.renderContents(data);
    if (cartItems) cartItems.renderContents(data);
    if (cartNotification) cartNotification.renderContents(data);
  } catch (error) {
    console.error('Sample side-tab add to cart failed', error);
  } finally {
    button.classList.remove('loading');
    button.querySelector('.loading__spinner')?.classList.add('hidden');
    button.removeAttribute('aria-disabled');
    if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    if (cartNotification && cartNotification.classList.contains('is-empty')) cartNotification.classList.remove('is-empty');
    syncSampleButtonStates();
  }
}

// Sample buttons live outside <product-form> (collection cards), so they are wired up here.
// This file can be included more than once per page (theme.liquid + section), and a second
// click listener would add every sample twice, hence the guard.
if (!window.sampleButtonsInitialised) {
  window.sampleButtonsInitialised = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sample-variant-id]');
    if (!button) return;

    event.preventDefault();
    addSampleSideTabToCart(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncSampleButtonStates());
  } else {
    syncSampleButtonStates();
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => syncSampleButtonStates());
  }
}
